import { useEffect } from "react";
import "./skills.css";

export const Skills = () => {
  useEffect(() => {
    const skillsBadges = document.querySelectorAll(".skill img");
    function handleMouseEnter(skill) {
      skill.src = `https://raw.githubusercontent.com/danielcranney/profileme-dev/4442a351ea1871ad8ba08a4ec82cb8eae9d73b8b/public/icons/skills/${skill.alt}-colored.svg`;
    }

    function handleMouseLeave(skill) {
      skill.src = `https://raw.githubusercontent.com/danielcranney/profileme-dev/4442a351ea1871ad8ba08a4ec82cb8eae9d73b8b/public/icons/skills/${skill.alt}-dark.svg`;
    }

    skillsBadges.forEach((skill) => {
      skill.addEventListener("mouseenter", () => {
        handleMouseEnter(skill);
      });
      skill.addEventListener("mouseleave", () => {
        handleMouseLeave(skill);
      });
    });

    function setColorToSkillBadges() {
      if (window.screen.width < 1024) {
        skillsBadges.forEach((skill) => {
          skill.src = `https://raw.githubusercontent.com/danielcranney/profileme-dev/4442a351ea1871ad8ba08a4ec82cb8eae9d73b8b/public/icons/skills/${skill.alt}-colored.svg`;
        });
      } else {
        skillsBadges.forEach((skill) => {
          skill.src = `https://raw.githubusercontent.com/danielcranney/profileme-dev/4442a351ea1871ad8ba08a4ec82cb8eae9d73b8b/public/icons/skills/${skill.alt}-dark.svg`;
        });
      }
    }
    
    setColorToSkillBadges();
  });

  return (
    <section className="skills" id="skills">
      <h2>Skills</h2>
      <div className="skills-badges">
        <a
          className="skill"
          href="https://developer.mozilla.org/en-US/docs/Glossary/HTML5"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://raw.githubusercontent.com/danielcranney/profileme-dev/4442a351ea1871ad8ba08a4ec82cb8eae9d73b8b/public/icons/skills/html5-dark.svg"
            alt="html5"
          />
        </a>
        <a
          className="skill"
          href="https://developer.mozilla.org/en-US/docs/Web/CSS"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://raw.githubusercontent.com/danielcranney/profileme-dev/4442a351ea1871ad8ba08a4ec82cb8eae9d73b8b/public/icons/skills/css3-dark.svg"
            alt="css3"
          />
        </a>
        <a
          className="skill"
          href="https://developer.mozilla.org/en-US/docs/Web/JavaScript"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://raw.githubusercontent.com/danielcranney/profileme-dev/4442a351ea1871ad8ba08a4ec82cb8eae9d73b8b/public/icons/skills/javascript-dark.svg"
            alt="javascript"
          />
        </a>
        <a
          className="skill"
          href="https://getbootstrap.com/docs/5.3/getting-started/introduction/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://raw.githubusercontent.com/danielcranney/profileme-dev/4442a351ea1871ad8ba08a4ec82cb8eae9d73b8b/public/icons/skills/bootstrap-dark.svg"
            alt="bootstrap"
          />
        </a>
        <a
          className="skill"
          href="https://sass-lang.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://raw.githubusercontent.com/danielcranney/profileme-dev/4442a351ea1871ad8ba08a4ec82cb8eae9d73b8b/public/icons/skills/sass-dark.svg"
            alt="sass"
          />
        </a>
        <a
          className="skill"
          href="https://react.dev/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://raw.githubusercontent.com/danielcranney/profileme-dev/4442a351ea1871ad8ba08a4ec82cb8eae9d73b8b/public/icons/skills/react-dark.svg"
            alt="react"
          />
        </a>
        <a
          className="skill"
          href="https://git-scm.com/doc"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://raw.githubusercontent.com/danielcranney/profileme-dev/4442a351ea1871ad8ba08a4ec82cb8eae9d73b8b/public/icons/skills/git-dark.svg"
            alt="git"
          />
        </a>
      </div>
    </section>
  );
};
